import Select from 'components/Select';
import React from 'react';
import { API } from 'utils/api';
import { useFetchData } from 'utils/hooks';

export default function PaymentVoucherSelect({
  // * Props
  name, label
}) {
  const [paymentMethodData] = useFetchData(API.PaymentMethod.all);

  return (
    <Select
      options={paymentMethodData}
      name={name}
      label={label}
    />
  );
}
